import {SearchDisplayContext, SearchResult, SearchResultType, SearchSortOption} from 'common/report/util/search/types';

export interface LoadEntityModalState {
  errored: boolean;
  isResultsLoading: boolean;
  lastSearchedText: string;
  name: string;
  open: boolean;
  // Keeps count of unique requests sent out in order
  requestIndex: number;
  results: SearchResult[];
  searchedText: string;
  selection: {
    owner: OwnerFilter[];
    report: SearchDisplayContext[];
    sort: SearchSortOption;
  };
  shortenedTable: boolean;
}

export interface RowEntity {
  rowType: SearchResultType | string;
  displayContext?: SearchDisplayContext;
  name: string;
  description: string;
  lastModified: string;
  lastModifiedSort?: number;
  lastModifiedDisplay: string;
  link?: string;
  report: string;
  popularityScore?: number;
  finalScore?: number;
  uniqueCount?: number;
  user: string; // this is user NAME
  userId: number;
  userEmail: string;
  editable: boolean;
  value: any;
}

export interface LoadEntityModalAttrs {
  'modal-title': string;
  open: boolean;
  'empty-message': string;
  'project-id': string;
  'track-name': string;
  'entities-loading': boolean;
  'display-context'?: SearchDisplayContext;
  icon?: string;
  'search-text': string;
  'user-id': number;
  'workspace-id': number;
  'default-sort-option': string;
}

export enum OwnerFilter {
  Shared = `Shared with you`,
  Owner = `Created by you`,
}

export enum Selection {
  Owner = `OwnerFilter`,
  Report = `ReportFilter`,
  Sort = `Sort`,
}

export enum TableField {
  Count = `count`,
  LastModified = `lastModified`,
  Name = `name`,
  User = `user`,
}
